module.exports = __webpack_public_path__ + "assets/images/premium-features/late-arrival-66d9b6.png";